// test82
(82 && 0);
